<template>
  <div class="contents-inner">
    <p class="hd-type-0n3">
      <span>選考プロセス</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="process"
      v-text="selection.selectionProcess"
    />

    <template v-for="index in [1,2,3]">
      <template v-if="isShow.interview(index)">
        <p
          :key="`title-${index}`"
          class="hd-type-0n3"
          :data-test="`title-${index}`"
        >
          <span>面接会場{{ index!==1?index:'' }}</span>
        </p>
        <p
          :key="`body-${index}`"
          class="mt20"
          :data-test="`body-${index}`"
        >
          <template v-if="selection[`zipCode${index}`]">
            〒 {{ selection[`zipCode${index}`] }}<br>
          </template>
          <span
            v-if="selection[`address${index}`]"
            class="pega-pre-wrap"
            :data-test="`address-${index}`"
            v-text="`${selection[`address${index}`]}\n`"
          />
          <template v-if="selection[`placeMapAddress${index}`]">
            <a
              :href="`${googleMapURL}${selection[`placeMapAddress${index}`]}`"
              target="_blank"
              :data-test="`map-${index}`"
            >[map]</a><br>
          </template>
          <template v-if="selection[`personInCharge${index}`]">
            担当者 ／ {{ selection[`personInCharge${index}`] }}<br>
          </template>
          <template v-if="selection[`tel${index}`]">
            Tel ／ {{ selection[`tel${index}`] }}
          </template>
        </p>
      </template>
    </template>

    <p class="hd-type-0n3">
      <span>問い合わせ</span>
    </p>
    <p
      class="mt20"
      data-test="inquiry"
    >
      <template v-if="companyName">
        {{ companyName }}<br>
      </template>
      <template v-if="selection.inquiryUrl">
        <a
          :href="selection.inquiryUrl"
          target="_blank"
          rel="nofollow"
          data-test="inquiryUrl"
        >{{ selection.inquiryUrl }}</a><br>
      </template>
      <template v-if="selection.inquiryZip">
        〒 {{ selection.inquiryZip }}<br>
      </template>
      <template v-if="selection.inquiryAddress">
        <span
          class="pega-pre-wrap"
          data-test="address"
          v-text="selection.inquiryAddress"
        /><br>
      </template>
      <template v-if="selection.inquiryPerson">
        担当者 ／ {{ selection.inquiryPerson }}<br>
      </template>
      <template v-if="selection.inquiryTel">
        Tel ／ {{ selection.inquiryTel }}<br>
      </template>
      <template v-if="selection.inquiryEmail">
        E-mail ／ {{ selection.inquiryEmail }}
      </template>
    </p>

    <template v-if="isShow.links">
      <p
        class="hd-type-0n3"
        data-test="link-title"
      >
        <span>関連リンク</span>
      </p>
      <p
        class="mt20"
        data-test="link-body"
      >
        <template v-for="index in [1,2,3]">
          <template v-if="selection[`companyLinkNm${index}`]">
            <a
              :key="`link-${index}`"
              :href="selection[`companyLinkUrl${index}`]"
              target="_blank"
              rel="nofollow"
              :data-test="`link-${index}`"
            >{{ selection[`companyLinkNm${index}`] }}</a><br :key="`br-${index}`">
          </template>
        </template>
      </p>
    </template>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    companyName: {
      type: String,
      default: ''
    },
    selection: {
      type: Object,
      required: true
    }
  }
}
</script>
